import React from 'react';

import { PhoneProviderContext } from '@app/providers/PhoneProvider/PhoneProvider';

const MultipleFamilyMatches: React.FC = () => {
	const contextPhone = React.useContext(PhoneProviderContext);

	if (!contextPhone?.state) throw new Error('Error PhoneProvider context');

	return (
		<div className="center-center-content">
			<div className="online-booking__error-code-component">
				<div className="text">
					<p>We’re sorry! We found multiple matches in our system.</p>
					<p>
						Please call us at
						{' '}
						<span className="inline-block">
							<a href={contextPhone.state.phoneNumberHref} className="inline-link">
								{contextPhone.state.phoneNumberDisplay}
							</a>
						</span>
						{' '}
						to help adjust your family information.
					</p>
				</div>
			</div>
		</div>
	);
};

export default MultipleFamilyMatches;
